export function makeTree(data, isParent, childField) {
  isParent = isParent || function(parent) {
    return this.pid === parent.id
  }

  const top = []
  childField = childField || 'children'

  data.forEach(function(child) {
    let isTop = true

    data.forEach(function(parent) {
      if (isParent.call(child, parent)) {
        if (!parent[childField]) {
          parent[childField] = []
        }
        parent[childField].push(child)
        isTop = false
        return false
      }
    })

    if (isTop) {
      top.push(child)
    }
  })

  return top
}

/**
 * 遍历树
 * @param data
 * @param callback
 * @param childField
 * @param level
 */
export function walkTree(data, callback, childField, level) {
  childField = childField || 'children'
  level = level || 0
  callback = callback || function() {
  }

  const _walk = function(data, callback, parent, level) {
    data.forEach(function(obj, index) {
      const children = obj[childField]

      if (children && children.length) {
        _walk(children, callback, obj, level + 1)
      }

      // 当前对象、父级对象、层级、当前对象的index
      callback.call(obj, obj, parent, level, index)
    })
  }

  if (data.length) {
    _walk(data, callback, null, level)
  } else {
    _walk([data], callback, null, level)
  }
}

/**
 * 遍历树
 * @param data
 * @param callback
 * @param childField
 * @param level
 */
export function walkTreeBefore(data, callback, childField, level) {
  childField = childField || 'children'
  level = level || 0
  callback = callback || function() {
  }

  const _walk = function(data, callback, parent, level) {
    data.forEach(function(obj, index) {
      // 当前对象、父级对象、层级、当前对象的index
      callback.call(obj, obj, parent, level, index)

      const children = obj[childField]

      if (children && children.length) {
        _walk(children, callback, obj, level + 1)
      }
    })
  }

  if (data.length) {
    _walk(data, callback, null, level)
  } else {
    _walk([data], callback, null, level)
  }
}
